var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDescription = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 4.45703C1.25 4.04282 1.58579 3.70703 2 3.70703H14C14.4142 3.70703 14.75 4.04282 14.75 4.45703C14.75 4.87124 14.4142 5.20703 14 5.20703H2C1.58579 5.20703 1.25 4.87124 1.25 4.45703ZM1.25 7.1237C1.25 6.70948 1.58579 6.3737 2 6.3737H11.3333C11.7475 6.3737 12.0833 6.70948 12.0833 7.1237C12.0833 7.53791 11.7475 7.8737 11.3333 7.8737H2C1.58579 7.8737 1.25 7.53791 1.25 7.1237ZM1.25 9.79036C1.25 9.37615 1.58579 9.04036 2 9.04036H14C14.4142 9.04036 14.75 9.37615 14.75 9.79036C14.75 10.2046 14.4142 10.5404 14 10.5404H2C1.58579 10.5404 1.25 10.2046 1.25 9.79036ZM1.25 12.457C1.25 12.0428 1.58579 11.707 2 11.707H11.3333C11.7475 11.707 12.0833 12.0428 12.0833 12.457C12.0833 12.8712 11.7475 13.207 11.3333 13.207H2C1.58579 13.207 1.25 12.8712 1.25 12.457Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDescription, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/description.fe2d9d95.svg";
export { ForwardRef as ReactComponent };